module.exports = __webpack_public_path__ + "img/gzh.23a8fc6b.jpg";